<table>
  <tbody>
    <tr>
      <td>
        <div class="form-group">
          <label>* Date from</label>
          <input type="text"
                 placeholder="From Date"
                 [(ngModel)]="fromDate"
                 class="form-control"
                 [bsConfig]="{containerClass:'theme-dark-blue', isAnimated: true,adaptivePosition: true,dateInputFormat: 'YYYY-MM-DD HH:mm:ss' }"
                 bsDatepicker>

        </div>
      </td>
      <td>
        <div class="form-group">
          <label>* Date to</label>
          <input type="text"
                 placeholder="To Date"
                 [(ngModel)]="toDate"
                 class="form-control"
                 [bsConfig]="{containerClass:'theme-dark-blue', isAnimated: true,adaptivePosition: true,dateInputFormat: 'YYYY-MM-DD HH:mm:ss' }"
                 bsDatepicker>
        </div>
      </td>
      <td>
        <br />
        <button class="btn btn-theme primary" (click)="ShowReport()">Apply</button>
      </td>
      <td>
        <br />
        <button class="btn btn-theme primary" (click)="PrintReport()">Print</button>
      </td>
    </tr>
  </tbody>
</table>
<br />
<br />
<table>
  <tbody>
    <tr>
      <td colspan="4">
        Summary of cash desk, can be filter by shift id, operator name and date and time.
      </td>
    </tr>
    <tr>
      <td>
        Cash-desk number
      </td>
      <td>
        SHIFT No.
      </td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>
        Operator name
      </td>
      <td>
      </td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>
        Opening of shift:
      </td>
      <td>
        Shift closure
      </td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>
      </td>
      <td>
      </td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>
        MOVEMENTS
      </td>
      <td>
      </td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>
      </td>
      <td>
      </td>
      <td>
        count
      </td>
      <td>
        value
      </td>
    </tr>

    <tr>
      <td>
        SINGLE-STAY COLLECTIONS
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        LOST TICKETS
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        MANUAL DATE TICKETS
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        PREPAID TICKETS
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        SET-VALUE CARDS SOLD :

      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        SET-VALUE CARDS RECHARGED :

      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        SUBSCRIBER CARDS SOLD :

      </td>
      <td>
      </td>
      <td>
        {{shiftSummary.CARD_SOLD_COUNT}}
      </td>
      <td>
        {{shiftSummary.CARD_SOLD_VALUE}}
      </td>
    </tr>
    <tr>
      <td>
        SUBSCRIBER CARDS RENEWED

      </td>
      <td>
      </td>
      <td>
        {{ shiftSummary.CARD_RENEW_COUNT}}
      </td>
      <td>
        {{shiftSummary.CARD_RENEW_VALUE}}
      </td>
    </tr>
    <tr>
      <td>
        surcharge
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        Total collection
      </td>
      <td>
      </td>
      <td>
        {{shiftSummary.CARD_TOTAL_COUNT}}
      </td>
      <td>
        {{shiftSummary.CARD_TOTAL_VALUE}}
      </td>
    </tr>
    <tr>
      <td>
        Discount
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        STAY AMOUNTS CANCELLATIONS (foc)
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        Total discount
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        PAYMENT METHOD
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        CASH
      </td>
      <td>
      </td>
      <td>
        {{shiftSummary.CASH_PAYMENT_COUNT}}
      </td>
      <td>
        {{shiftSummary.CASH_PAYMENT_VALUE}}
      </td>
    </tr>
    <tr>
      <td>
        E- payment
      </td>
      <td>
      </td>
      <td>
        {{shiftSummary.E_PAYMENT_COUNT}}
      </td>
      <td>
        {{shiftSummary.E_PAYMENT_VALUE}}
      </td>
    </tr>
    <tr>
      <td>
        i-By cc/dc
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        ii-e wallet
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        Prepaid cards(Fastag)
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        SHIFT TOTALS
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        CASH ON HAND
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        WITHDRAWAL FOR CLOSURE
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        SHIFT PROFIT
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        COLLECTIONS
      </td>
      <td>
      </td>
      <td>
        {{shiftSummary.COLLECTIONS}}
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        DISCOUNTS
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        SURCHARGE
      </td>
      <td>
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        Profit
      </td>
      <td>
      </td>
      <td>
        {{shiftSummary.PROFIT}}
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        Cash
      </td>
      <td>
      </td>
      <td>
        {{shiftSummary.CASH_PAYMENT_VALUE}}
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        E-Payment
      </td>
      <td>
      </td>
      <td>
        {{shiftSummary.E_PAYMENT_VALUE}}
      </td>
      <td>
      </td>
    </tr>
  </tbody>
</table>
